import React from 'react';
import check from '@assets/images/icon/ic-checkmark-white@3x.png';
import './imageSelectableCard.scss';

type Props = {
  title?:string;
  subTitle?:string; 
  src:string;
  checked: boolean;
  onClick?:()=>void;
}
const ImageSelectableCard = ({title, subTitle, src, checked, onClick}:Props) => {
  return (
    <div className={`image-selectable-card`} onClick={onClick}>
      <img src={src} alt='hall_style_img'/>
     {checked && 
      <div className='selected' >
        <img src={check} alt='checked'/>
      </div>}

      <div className='contents'>
        {title && <h2 className='bold'>{title}</h2>}
        {subTitle && <p>{subTitle}</p>}
      </div>
    </div>
  );
};

export default ImageSelectableCard;